// Layer config map
export const LAYERS = {
  1: {
    age: 1,
    themeKey: "layer_1",
    color: "#38BDF8",
    colorDark: "#0284c7",
    bg: "/assets/layers/bg1.png",
    baby: "/assets/layers/baby1.png",
    companionKey: "comp_1",
    games: [
      "peekaboo",
      "bubbles",
      "touch_sound",
      "contrast",
      "drum",
      "farmyard",
      "glow",
      "falling",
      "emotions",
      "silhouette",
      "rattle",
      "sweeper"
    ],
    accent: "from-sky-200 to-sky-100",
  },
  2: {
    age: 2,
    themeKey: "layer_2",
    color: "#EAB308",
    colorDark: "#a16207",
    bg: "/assets/layers/bg2.png",
    baby: "/assets/layers/baby4.png",
    companionKey: "comp_2",
    games: [
      "animals",
      "body",
      "sort",
      "mimicry",
      "blow",
      "toy_match",
      "fruit_basket",
      "toy_phone",
      "balloon_float",
      "hammering",
      "donut_stack",
      "sand_sweeper"
    ],
    accent: "from-yellow-200 to-yellow-100",
  },
  3: {
    age: 3,
    themeKey: "layer_3",
    color: "#22C55E",
    colorDark: "#15803d",
    bg: "/assets/layers/bg3.png",
    baby: "/assets/layers/baby3.png",
    companionKey: "comp_3",
    games: [
      "match_color",
      "puzzle",
      "feed",
      "tooth_match",
      "bubble_bath",
      "dress_up",
      "bee_maze",
      "angklung",
      "insect_finder",
      "rabbit_harvest",
      "kendang",
      "paint_sweeper"
    ],
    accent: "from-green-200 to-green-100",
  },
  4: {
    age: 4,
    themeKey: "layer_4",
    color: "#F87171",
    colorDark: "#b91c1c",
    bg: "/assets/layers/bg4.png",
    baby: "/assets/layers/baby2.png",
    companionKey: "comp_4",
    games: [
      "count",
      "letters",
      "memory",
      "frog_hop",
      "xylophone",
      "wheel_match",
      "ant_maze",
      "cloud_shape",
      "pizza_toppings",
      "squirrel_tap",
      "farm_match",
      "window_sweeper"
    ],
    accent: "from-red-200 to-orange-100",
  },
  5: {
    age: 5,
    themeKey: "layer_5",
    color: "#A855F7",
    colorDark: "#6b21a8",
    bg: "/assets/layers/bg5.png",
    baby: "/assets/layers/baby5.png",
    companionKey: "comp_5",
    games: [
      "words",
      "math",
      "pattern",
      "subtraction",
      "spelling",
      "double_gear",
      "honey_maze",
      "tangram_match",
      "pizza_fraction",
      "mole_whack",
      "angklung_melody",
      "rainbow_paint"
    ],
    accent: "from-purple-200 to-purple-100",
  },
};

export const ageList = [1, 2, 3, 4, 5];
